import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Chart, PieController, ArcElement, Tooltip, Legend } from 'chart.js';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';

@Component({
  selector: 'app-modal-pot-per-reg-hospitals',
  imports: [CommonModule],
  templateUrl: './modal-pot-per-reg-hospitals.component.html',
  styleUrl: './modal-pot-per-reg-hospitals.component.css'
})
export class ModalPotPerRegHospitalsComponent implements OnInit {

  @Input() regionId!: number | null;
  @Input() medicineId!: number;
  @Input() countryId!: number;
  @Input() regionName!: string | null;

  chart: any;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  labelsData?: string[] = [];
  percentageData?: string[] = [];
  backgroundColors?: string[] = [];
  isLoading = true;
  isDataEmpty = false;
  hasMoreSpanToOverflow: boolean = false;

  constructor (private dataService: DataService) { }

  ngOnInit (): void {
    if (this.regionId) {
      this.dataService.getHospitalInfoData(this.medicineId, this.countryId, this.regionId).subscribe((data: any) => {

        if (data.length > 0) {
          const totalPotentialNumber = data.reduce((sum: any, item: any) => sum + item.potentialNumber, 0);

          data.map((item: any) => {
            let potentialPercentage = totalPotentialNumber ? (item.potentialNumber / totalPotentialNumber) * 100 : 0;
            this.labelsData?.push(item.name);
            this.percentageData?.push(potentialPercentage.toFixed(2).toString());
          });

          this.backgroundColors = this.getRandomColors(data.length);
          this.createPieChart();
        } else {
          this.isLoading = false;
          this.isDataEmpty = true;
        }
      });
    }
  }

  oncloseModal (value: boolean) {
    this.closeModal.emit(value);
    this.backgroundColors = [];
    this.labelsData = [];
    this.percentageData = [];
  }

  createPieChart (): void {
    Chart.register(PieController, ArcElement, Tooltip, Legend);

    const ctx = document.getElementById('myPieChart') as HTMLCanvasElement;
    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.labelsData,
        datasets: [{
          data: this.percentageData,
          backgroundColor: this.backgroundColors,
        }],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
      },
    });

    this.generateCustomLabels();
    this.isLoading = false;
  }

  generateCustomLabels (): void {
    const legendContainer = document.getElementById('pieChartLabels');

    if (legendContainer) {
      legendContainer.innerHTML = '';

      const labelsData = this.labelsData ?? [];
      const backgroundColors = this.backgroundColors ?? [];
      const percentageData = this.percentageData ?? [];



      // Loop through labels and generate custom label elements
      labelsData.forEach((label, index) => {
        const color = backgroundColors[index] ?? '#cccccc';  // Use a default color if undefined
        const percentage = percentageData[index] ?? 0;  // Use 0 if percentage data is missing
        const titleLabel = this.toTitleCase(label);

        const labelElement = document.createElement('div');
        labelElement.innerHTML = `
          <div style="display: inline-block; width: 15px; height: 15px; background-color: ${color}; margin-right: 8px;"></div>

          <span>${titleLabel} &nbsp;-&nbsp; <h1 class="inline">${parseFloat(percentage).toFixed(2)}%</h1></span>
        `;
        labelElement.style.display = 'flex';
        labelElement.style.alignItems = 'center';
        labelElement.style.marginBottom = '5px';

        legendContainer.appendChild(labelElement);
        if (legendContainer.querySelectorAll("span").length > 8) {

          this.hasMoreSpanToOverflow = true;
        } else {
          this.hasMoreSpanToOverflow = false;
        }
      });
    } else {
      console.error('Legend container not found.');
    }
  }

  toTitleCase (str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getRandomColors(length: number): string[] {
  const colors: string[] = [];
  for (let i = 0; i < length; i++) {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
  }
  return colors;
}

getHeight(): string {
  const length = this.labelsData?.length || 0;
  if (length < 10) return '300px';
  if (length >= 11 && length <= 15) return '350px';
  if (length > 15) return '400px';
  return 'auto'; 
}

}
